import React from "react";
import { Formik, Form } from "formik";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useDispatch } from "react-redux";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { InputLabel } from "@mui/material";

import { BorderLinearProgress } from "../../../../components/LoadingComponent";
import { addOrEditHRInfo } from "../../../../store/ducks/duckHr";

const HrInfoForm = ({ initialValues, isEdit, handleClose, open, hrId }) => {
  const dispatch = useDispatch();

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={(values) => {
          let errors = {};

          if (!values.monthNumber) {
            errors.monthNumber = "Required";
          }

          if (!values.url) {
            errors.url = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          values = {
            ...values,
            id: values.id === 0 ? 0 : values.id,
            hRId: hrId,
          };

          let message = values.id > 0 ? "Edited" : "Added";

          return dispatch(addOrEditHRInfo(values, hrId, () => setSubmitting(false))).then(() => {
            handleClose();
            enqueueSnackbar(`${message} Hr Document Successfully`, {
              variant: "success",
            });
          });
        }}
      >
        {({ submitForm, isSubmitting, values }) => (
          <Form>
            <Dialog
              fullWidth
              aria-labelledby="form-dialog-title"
              maxWidth="md"
              open={open}
              onClose={handleClose}
            >
              {isSubmitting && <BorderLinearProgress />}
              <DialogTitle id="form-dialog-title">
                {isEdit && initialValues?.id !== 0
                  ? "Edit"
                  : !isEdit && initialValues?.id !== 0
                    ? "Details"
                    : "Add"}
              </DialogTitle>
              <DialogContent style={{ overflowY: initialValues.id !== 0 ? "scroll" : "hidden" }}>
                <Grid
                  container
                  spacing={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Grid
                    container
                    spacing={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                      justifyContent: "left",
                    }}
                  >
                    <Grid item xs={4}>
                      <InputLabel id="labelMonth">Month</InputLabel>
                      <Select
                        fullWidth
                        id="demo-simple-select-filled"
                        labelId="labelMonth"
                        margin="dense"
                        name="monthNumber"
                        variant="outlined"
                        onChange={(e) => (values.monthNumber = parseInt(e.target.value))}
                      >
                        <MenuItem value={7}>January</MenuItem>
                        <MenuItem value={8}>February</MenuItem>
                        <MenuItem value={9}>March</MenuItem>
                        <MenuItem value={10}>April</MenuItem>
                        <MenuItem value={11}>May</MenuItem>
                        <MenuItem value={12}>June</MenuItem>
                        <MenuItem value={1}>July</MenuItem>
                        <MenuItem value={2}>August</MenuItem>
                        <MenuItem value={3}>September</MenuItem>
                        <MenuItem value={4}>October</MenuItem>
                        <MenuItem value={5}>November</MenuItem>
                        <MenuItem value={6}>December</MenuItem>
                      </Select>
                    </Grid>

                    <Grid item xs={4}>
                      <InputLabel id="labelUrl">Url</InputLabel>
                      <TextField
                        fullWidth
                        margin="dense"
                        name="url"
                        type="text"
                        variant="outlined"
                        onChange={(e) => (values.url = e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button color="primary" variant="contained" onClick={handleClose}>
                  Close
                </Button>
                {isEdit && (
                  <Button color="primary" type="submit" variant="contained" onClick={submitForm}>
                    Save
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default HrInfoForm;
